import { UserRoleEnum } from '@qse/constants'
import { detectCurrentApp } from '@qse/utils'

/**
 * Realtime is tenant-scoped. A connection record is written to the caller's tenant
 * schema, so only roles that carry a tenant can open a socket.
 *
 * A SUPER_ADMIN has no tenant schema. Its `$connect` integration reaches the backend
 * without tenant context, the query falls through to the shared database where
 * `RT_UserConnections` does not exist, and the handshake fails with a 500. The
 * reconnect policy only stops on 401, so a 500 retries every five seconds for as long
 * as the tab stays open.
 *
 * The admin app already gates on role (see `useAdminRealtime`). This is the same gate
 * for the dashboard app, shared by both of its `useRealtime` call sites so the two
 * cannot drift apart.
 */
export const canConnectRealtime = (userRole?: UserRoleEnum): boolean =>
  detectCurrentApp().isDashboard &&
  (userRole === UserRoleEnum.TENANT_ADMIN || userRole === UserRoleEnum.TENANT_USER)
